import { FC } from 'react'
import styled from 'styled-components'
import { BaseButton } from '../../buttons'
import ChevronRightIcon from '@tuhi/components/assets/icons/buttons/chevronRight.svg'
import ChevronLeftIcon from '@tuhi/components/assets/icons/buttons/chevronLeft.svg'

const buttonSize = '3em'

const Button = styled(BaseButton)`
    border-radius: 50%;
    width: ${buttonSize};
    height: ${buttonSize};
    padding: 1em;
    box-sizing: content-box;
    background-color: ${(p) => p.theme.colors.white};

    &:hover {
        color: ${(p) => p.theme.colors.white};
        background-color: ${(p) => p.theme.colors.primaryGreen};
    }
`

interface Props {
    slideDirection: 'next' | 'previous'
    onClick: () => void
}

export const SlideButton: FC<Props> = ({ slideDirection, onClick }) => {
    return (
        <Button onClick={onClick}>
            {slideDirection === 'next' ? (
                <span
                    style={{
                        width: buttonSize,
                        height: buttonSize,
                        display: 'inline-block',
                    }}
                >
                    <ChevronRightIcon />
                </span>
            ) : (
                <span
                    style={{
                        width: buttonSize,
                        height: buttonSize,
                        display: 'inline-block',
                    }}
                >
                    <ChevronLeftIcon />
                </span>
            )}
        </Button>
    )
}
